<div class="Akte card">
  @if(IsLoading)
  {
  <div class="loadingBar">
    <splash></splash>
    <h2>Laden...</h2>
  </div>
  }
  @else
  {

  @if(IsAddDialog)
  {
  <div class="row AkteHeader">
    <div class="col">
      <div class="AddNewPatient" (keyup.enter)="CheckVersicherungsNrOrAddUser()">
        <h3>Neuen Patienten Anlegen:</h3>
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" id="VersicherungsNR" [(ngModel)]="VersicherungsNr" [EKVNummerMask]="VNummerTypeSelect" [disabled]="!VNummerEnabeld" [readonly]="!VNummerEnabeld" >
              <label for="VersicherungsNR" class="form-check-label">Versicherungs Nr.</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" [(ngModel)]="VNummerTypeSelect"   [value]="VNummerType.GKV">
              <label class="form-check-label" for="inlineRadio1">GKV / Suche</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"  [(ngModel)]="VNummerTypeSelect"  [value]="VNummerType.PKV">
              <label class="form-check-label" for="inlineRadio2">PKV</label>
            </div>
            <div class="form-check form-check-inline" *Authorize="Rights.CreateCompanyEntrys">
              <input class="form-check-input" type="radio" name="inlineRadioOptions" [(ngModel)]="VNummerTypeSelect"  id="inlineRadio3" [value]="VNummerType.Company" >
              <label class="form-check-label" for="inlineRadio3">Firma</label>
            </div>
          </div>
          <div class="col-3">
            <div class="btn btn-secondary" (click)="CheckVersicherungsNrOrAddUser()">Hinzufügen</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body AkteBody"></div>
  }
  @else
  {
  <div class="row AkteHeader">
    <div class="col">
      <Akte-Patient [Patient]="Akte?.patient" (PatientChange)="pruefePatientAndReloadIfNeeded($event)"  [OrderStep]="OrderStep"></Akte-Patient>
    </div>
  </div>

  <div class="card-body AkteBody">
    <app-offcanvas side="left"
                   iconClass="bi bi-list-ul"
                   activeIconClass="bi bi-list-ul" btnTop="50px" TitelText="Aufträge">

      <div class="ScrallableList">
        <div class="AuftragListe">
          <h3>Aufträge</h3>
          @for (auftrag of Akte?.aktiveAuftraege ?? []; track auftrag.key) {
          <div class="row" (click)="SelectAuftrag(auftrag)">
            <div class="col">{{ auftrag.key }} v. {{ auftrag.version }}</div>
            <div class="col-3">PG {{ auftrag.pflegegruppe }}</div>
            <div class="col"> Status {{ auftrag.status }}</div>
          </div>
          } @empty {
          <i>There are no items.</i>
          }
        </div>
        <hr />
        <div class="AuftragListe">
          <h3>Ausgelaufene Aufträge</h3>
          @for (auftrag of Akte?.vergangeneAuftraege ?? []; track auftrag.key) {
          <div class="row" (click)="SelectAuftrag(auftrag)">
            <div class="col">{{ auftrag.key }} v. {{ auftrag.version }}</div>
            <div class="col-2">PG {{ auftrag.pflegegruppe }}</div>
            <div class="col"></div>
          </div>
          } @empty {
          <i>There are no items.</i>
          }
        </div>
        <hr />
        <div class="AddNewOrder" (keyup.enter)="AddNewOrder()">
          <h3>Neuen Auftrag hinzufügen</h3>
          <PflegegruppeSelect [(Pflegegruppe)]="NewOrderPG"></PflegegruppeSelect>
          <div class="AddNewOrder">

            <div class="btn btn-success" (click)="AddNewOrder()"><i class="bi bi-plus-circle"></i> Anlegen</div>
          </div>
        </div>
      </div>

    </app-offcanvas>

    <div ngTabs>
      <ul ngTabList selectionMode="follow" selectedTab="VertraegeTab">
        <li ngTab value="VertraegeTab">Verträge</li>
        <li ngTab value="NotitzenTab">Notizen ({{Notitzen?.length}})</li>
        <li ngTab value="TodoTab">to do`s ({{ openTodosCount }})</li>
        <li ngTab value="VersandTab" *Authorize="Rights.VersandHistorie">Versand Historie</li>
        <li ngTab value="GeraeteTab" *Authorize="Rights.GeraeteHistorie">Geräte Historie</li>
      </ul>
      <div ngTabPanel value="VertraegeTab">
        <ng-template ngTabContent>
          @if(OffenerAuftrag == null)
          {
          <div class="AddNewOrder" (keyup.enter)="AddNewOrder()" *IsSpezialUser>
            <PflegegruppeSelect [(Pflegegruppe)]="NewOrderPG"></PflegegruppeSelect>
            <div class="AddNewOrder">
              <h3>Neuen Auftrag hinzufügen</h3>
              <div class="btn btn-success" (click)="AddNewOrder()"><i class="bi bi-plus-circle"></i> Anlegen</div>
            </div>
          </div>
          }
          @else
          {

          @if(OffenerAuftrag && OffenerAuftrag != null && OffenerAuftrag.pflegegruppe == 52 && OffenerAuftrag.leitstelle && OffenerAuftrag.leitstelle.key > 0)
          {


          <div class="btn FunctionBtn left" style="top: 120px" (click)="SendLeitstelleEdit()" *IsSpezialUser
               [class.btn-success]="OffenerAuftrag.leitstelle?.versand != null && OffenerAuftrag.leitstelle.versand != undefined"
               [class.btn-primary]="!(OffenerAuftrag.leitstelle?.versand != null && OffenerAuftrag.leitstelle.versand != undefined)"
               title="Leitstelle">
            <i class="bi bi-envelope-check"></i>
          </div>
          @if(OffenerAuftrag.leitstelle?.versand != null && OffenerAuftrag.leitstelle?.versand != undefined)
          {
          <div class="btn FunctionBtn left"
               [class.btn-secondary]="OffenerAuftrag.geraet?.angemeldet != true"
               [class.btn-danger]="OffenerAuftrag.geraet?.angemeldet"
               style="top: 190px" (click)="SendLeitstelleRevoke()" *IsSpezialUser
               title="Leitstelle Abmelden">
            <i class="bi bi-envelope-x-fill"></i>
          </div>
          }

          }

          @if(ApiUser.HatVolleBerechtigung && MipAllowed)
          {
          <div class="btn btn-primary FunctionBtn left" style="top:260px" (click)="ResendMip()" [class.alreadySend]="mipAlreadySend"
               title="MIP Antrag Versenden">
            <i class="bi bi-send-fill"></i>
          </div>
          }
          <Akte-Vertrag [Auftrag]="OffenerAuftrag" (AuftragChange)="handleAuftragChange($event)"  [VersicherungsNr]="VersicherungsNr" ></Akte-Vertrag>
          <app-offcanvas side="right" *IsSpezialUser
                         iconClass="bi bi-folder-fill"
                         activeIconClass="bi bi-folder-fill" btnTop="50px" TitelText="Dateien">

            <FileList [Patient]="Akte?.patient" [(Auftrag)]="OffenerAuftrag"></FileList>
          </app-offcanvas>
          @if(OffenerAuftrag?.beendigung?.ruekholung?.zeitpunkt)
          {
          <app-offcanvas side="right" *IsSpezialUser
                         iconClass="bi bi-backspace"
                         activeIconClass="bi bi-folder-fill" btnTop="120px" TitelText="Rückholung / Rückabwicklung">

            <Rueckabwicklung [Patient]="Akte?.patient" [(Auftrag)]="OffenerAuftrag"></Rueckabwicklung>
          </app-offcanvas>
          }
          <div class="btn btn-primary FunctionBtn" style="top:190px" *IsSpezialUser><i class="bi bi-arrow-repeat" (click)="RefreshOrder()" title="Refresh"></i></div>
          @if(OffenerAuftrag != null && OffenerAuftrag.pflegegruppe != 52)
          {
          <div class="btn btn-primary FunctionBtn" style="top:260px" (click)="OpenArtikelEdit()" title="Artikel Liste" *IsSpezialUser><i class="bi bi-box2-heart-fill"></i></div>
          }

            @if(OffenerAuftrag != null && OffenerAuftrag.pflegegruppe == 52 && OffenerAuftrag.status == 200 )
            {
              <div *Authorize="Rights.ChangeDevices" class="btn btn-primary FunctionBtn" style="top:260px" (click)="RotateDevice()" title="Geraete Tausch" ><i class="fa-solid fa-arrows-turn-to-dots"></i></div>
            }

          }

        </ng-template>
      </div>
      <div ngTabPanel value="NotitzenTab">
        <ng-template ngTabContent>
          <Notitzen [patient]="Akte?.patient" [(Items)]="Notitzen"></Notitzen>
        </ng-template>
      </div>
      <div ngTabPanel value="TodoTab">
        <ng-template ngTabContent>
          <ToDos [patient]="Akte?.patient" [(Items)]="ToDos"></ToDos>
        </ng-template>
      </div>
      <div ngTabPanel value="VersandTab" *Authorize="Rights.VersandHistorie">
        <ng-template ngTabContent>
        @if(Akte?.patient?.versicherungsnummer !== ''){
          <DataGridView DataUrl="/Backend/Api/V2/VersandAuftraege/Akte/{{Akte?.patient?.versicherungsnummer}}/List" KeyProperty="key" [UseUrlFilter]="false" [CustomiseRowCssClass]="(r) => r.versand ? 'Versand' : 'Retoure'" >
            <DataGridViewColumn field="auftragID" header="Auftrags DCO-ID" [DataType]="Types.Number" ></DataGridViewColumn>
            <DataGridViewColumn field="seriennummer" header="Seriennummer" [DataType]="Types.String"></DataGridViewColumn>
            <DataGridViewColumn field="clipID" header="ClipID" [DataType]="Types.String"></DataGridViewColumn>
            <DataGridViewColumn field="created" header="Erstellt" [DataType]="Types.Date" format="dd.MM.yyyy"></DataGridViewColumn>
            <DataGridViewColumn field="tracking" header="Tracking Nr." [DataType]="Types.String"></DataGridViewColumn>
            <DataGridViewColumn field="tracking" header="" [DataType]="Types.String">
              <ng-template #cell let-row>
                <versand-stepper [CurrentStatus]="row.trackingStatus"></versand-stepper>
              </ng-template>
            </DataGridViewColumn>
          </DataGridView>
        }
        </ng-template>
      </div>
      <div ngTabPanel value="GeraeteTab" *Authorize="Rights.GeraeteHistorie">
        <ng-template ngTabContent>
        @if(Akte?.patient?.versicherungsnummer !== ''){
          <DataGridView DataUrl="/Backend/Api/V2/GeraeteHistorie/ByPatient/{{Akte?.patient?.versicherungsnummer}}/List" KeyProperty="geraeteID" [UseUrlFilter]="false" >
            <DataGridViewColumn field="auftragsID" header="Auftrags DCO-ID" [DataType]="Types.Number"></DataGridViewColumn>
            <DataGridViewColumn field="Serailnumber" header="Seriennummer" [DataType]="Types.String"></DataGridViewColumn>
            <DataGridViewColumn field="clipID" header="ClipID" [DataType]="Types.String"></DataGridViewColumn>
            <DataGridViewColumn field="datum" header="Datum" [DataType]="Types.Date" format="dd.MM.yyyy"></DataGridViewColumn>
            <DataGridViewColumn field="tauschDatum" header="austausch Datum" [DataType]="Types.Date" format="dd.MM.yyyy"></DataGridViewColumn>
            <DataGridViewColumn field="tracking" header="Tracking Nr." [DataType]="Types.String"></DataGridViewColumn>
          </DataGridView>
        }
        </ng-template>
      </div>
    </div>
  </div>
  }
  }
</div>
<ng-template #successVerTpl> Versand erfolgreich! </ng-template>
<ng-template #FaildVerTpl> Versand fehlgeschlagen! </ng-template>
